import api from './axiosConfig';

// Call backend createToken to create a session token for a user
export const createToken = async (userData) => {
  try {
    const response = await api.post('/sessionTokens/createToken', userData);
    console.log("Session token created", response.data);
    return response.data;
  } catch (error) {
    throw (error.response && error.response.data) || new Error('An error occurred');
  }
};

// Call backend extendSession to extend the session token for a user
export const extendSession = async () => {
  try {
    const response = await api.post('/sessionTokens/extendSession');
    return response.data;
  } catch (error) {
    throw (error.response && error.response.data) || new Error('An error occurred');
  }
};

// Call backend deleteToken to delete the session token for a user
export const deleteToken = async () => {
  try {
    const response = await api.delete('/sessionTokens/deleteToken');
    return response.data;
  } catch (error) {
    throw (error.response && error.response.data) || new Error('An error occurred');
  }
};
 